// extracted by mini-css-extract-plugin
module.exports = {"test":"antd-pro-components-qualification-style-test"};